//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../no/Session.js";
import "../Preferences/Preferences.SessionPreferences.js";
let d=[[[0,"AccelerationColor",1,0],[0,"ActivateFeatureGroupWithRollback",1,0],[0,"AllowEditingOfDimensionOfInternalSketch",1,0],[0,"AssociativeEditFreeForm",1,0],[0,"BodyType",1,0],[0,"BooleanFaceProperties",1,0],[0,"ConvertAnalyticToConvergentAngularTolerance",1,1],[0,"ConvertAnalyticToConvergentDistanceTolerance",1,1],[0,"CurvatureColor",1,0],[0,"CurveFitMethod",1,0],[0,"DelayModelUpdates",0,0],[0,"DeleteChildFeaturesOption",1,0],[0,"DisplayLegacyFeatureName",1,0],[0,"DynamicUpdate",1,0],[0,"EditWithRollbackUponDoubleClick",1,0],[0,"EnableTrimmedAnimation",1,0],[0,"EndpointDisplayColor",1,0],[0,"EndpointDisplayInheritColor",1,0],[0,"EndpointDisplayStyle",1,0],[0,"FreeFormConstructionResult",1,0],[0,"ImmediateChildren",1,0],[0,"InterruptUpdateOnError",1,0],[0,"InterruptUpdateOnMissingReferences",1,0],[0,"InterruptUpdateOnWarning",1,0],[0,"LinkedAndExtractedGeometryProperties",1,0],[0,"MakeCurrentOnError",1,0],[0,"MakeDatumsInternal",1,0],[0,"MakeSketchesInternal",1,0],[0,"ModelDelayUpdateGranilarity",0,0],[0,"NewFaceProperties",1,0],[0,"NotifyOnDelete",1,0],[0,"PoleDisplayColor",1,0],[0,"PoleDisplayInheritColor",1,0],[0,"PoleDisplayStyle",1,0],[0,"PoleEditColor",1,0],[0,"PoleEditInheritColor",1,0],[0,"PoleEditStyle",1,0],[0,"PolylineDisplayColor",1,0],[0,"PolylineDisplayInheritColor",1,0],[0,"PolylineDisplayStyle",1,0],[0,"PolylineEditColor",1,0],[0,"PolylineEditInheritColor",1,0],[0,"PolylineEditStyle",1,0],[0,"PositionColor",1,0],[0,"PreviewResolution",1,0],[0,"SaveDataForFeatureEdit",1,0],[0,"ShareGeometriesOption",1,0],[0,"ShowSimuationUiInModeling",1,0],[0,"SketchDefaultAction",1,0],[0,"SketchEditOption",1,1],[0,"SplineDefaultActionType",1,0],[0,"SurfaceExtension",1,0],[0,"TangentColor",1,0],[0,"TreatOneDegreeBsplineAsPolyline",1,1],[0,"UpdateDelayed",1,1],[0,"UpdateFailureReportPreference",1,0],[0,"UpdatePending",1,1],[0,"UseTriangularMesh",1,0]],[[["delay_model_updates","modelDelayUpdateGranularityOption","undoMarkId"],"SetDelayModelUpdatesAndGranularity",{},3,0],[[],"GetShowSymbolicThreadDecalSticker",{R_:{showSymbolicThreadDecalSticker:''}},0,0],[["showSymbolicThreadDecalSticker"],"SetShowSymbolicThreadDecalSticker",{},1,0]],[]];
SPLM.Preferences.SessionModeling = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.SessionModeling";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.SessionModeling.NewFacePropertiesInheritance = Object.freeze({
    "Body" : "Body", "PartDefault" : "PartDefault"});

SPLM.Preferences.SessionModeling.BooleanFacePropertiesInheritance = Object.freeze({
    "TargetBody" : "TargetBody", "ToolBody" : "ToolBody"});

SPLM.Preferences.SessionModeling.LinkedAndExtractedGeometryPropertiesInheritance = Object.freeze({
    "ParentObject" : "ParentObject", "PartDefault" : "PartDefault"});

SPLM.Preferences.SessionModeling.DynamicUpdateType = Object.freeze({
    "None" : "None", "Incremental" : "Incremental", "Continuous" : "Continuous"});

SPLM.Preferences.SessionModeling.ImmediateChildrenType = Object.freeze({
    "FirstLevel" : "FirstLevel", "All" : "All"});

SPLM.Preferences.SessionModeling.BodyTypeOption = Object.freeze({
    "Solid" : "Solid", "Sheet" : "Sheet"});

SPLM.Preferences.SessionModeling.FreeFormConstructionResultType = Object.freeze({
    "Plane" : "Plane", "BSurface" : "BSurface"});

SPLM.Preferences.SessionModeling.SplineDefaultActionTypes = Object.freeze({
    "StudioSpline" : "StudioSpline", "Xform" : "Xform"});

SPLM.Preferences.SessionModeling.CurveFitMethodType = Object.freeze({
    "Cubic" : "Cubic", "Quintic" : "Quintic", "Advanced" : "Advanced"});

SPLM.Preferences.SessionModeling.PreviewResolutionType = Object.freeze({
    "None" : "None", "Coarse" : "Coarse", "Standard" : "Standard", "Fine" : "Fine", "ExtraFine" : "ExtraFine", "SuperFine" : "SuperFine", "UltraFine" : "UltraFine"});

SPLM.Preferences.SessionModeling.SketchDefaultActionType = Object.freeze({
    "EditWithRollback" : "EditWithRollback", "Edit" : "Edit"});

SPLM.Preferences.SessionModeling.SketchEditType = Object.freeze({
    "InTaskEnvironment" : "InTaskEnvironment", "Direct" : "Direct"});

SPLM.Preferences.SessionModeling.ModelDelayUpdateGranilarityType = Object.freeze({
    "Group" : "Group", "Feature" : "Feature"});

SPLM.Preferences.SessionModeling.PolylineStyleType = Object.freeze({
    "Solid" : "Solid", "Dashed" : "Dashed", "Phantom" : "Phantom", "Centerline" : "Centerline", "Dotted" : "Dotted", "Longdashed" : "Longdashed", "Dotteddashed" : "Dotteddashed", "Eight" : "Eight", "Nine" : "Nine", "Ten" : "Ten", "Eleven" : "Eleven"});

SPLM.Preferences.SessionModeling.PoleDisplayStyleType = Object.freeze({
    "None" : "None", "OpenCircle" : "OpenCircle", "FilledCircle" : "FilledCircle", "PlusSign" : "PlusSign", "Cross" : "Cross"});

SPLM.Preferences.SessionModeling.PoleEditStyleType = Object.freeze({
    "Sphere3d" : "Sphere3d", "OpenCircle" : "OpenCircle", "FilledCircle" : "FilledCircle", "PlusSign" : "PlusSign", "Cross" : "Cross"});

SPLM.Preferences.SessionModeling.EndpointDisplayStyleType = Object.freeze({
    "OpenCircle" : "OpenCircle", "FilledCircle" : "FilledCircle", "PlusSign" : "PlusSign", "Cross" : "Cross", "Point" : "Point", "Asterisk" : "Asterisk", "PoundSign" : "PoundSign", "FilledSquare" : "FilledSquare", "FilledTriangle" : "FilledTriangle", "FilledDiamond" : "FilledDiamond", "Centerline" : "Centerline"});

SPLM.Preferences.SessionModeling.ShareGeometriesOnSaveType = Object.freeze({
    "DontShare" : "DontShare", "Share" : "Share"});

SPLM.Preferences.SessionModeling.SurfaceExtensionOption = Object.freeze({
    "Linear" : "Linear", "Soft" : "Soft", "Reflective" : "Reflective", "Natural" : "Natural", "Arc" : "Arc"});

SPLM.Preferences.SessionModeling.SaveDataForFeatureEditOption = Object.freeze({
    "None" : "None", "FastRollback" : "FastRollback", "FastRollbackAndPreviousStateOfFailedFeature" : "FastRollbackAndPreviousStateOfFailedFeature"});

SPLM.Preferences.SessionModeling.DeleteChildFeaturesOptionType = Object.freeze({
    "Yes" : "Yes", "No" : "No", "Ask" : "Ask"});

export default SPLM;